import { useState, useEffect } from 'react';
import './LetterTile.css';

function LetterTile({ letter, evaluation, isRevealed, delay, position }) {
  const [shouldFlip, setShouldFlip] = useState(false);

  useEffect(() => {
    if (isRevealed) {
      setTimeout(() => {
        setShouldFlip(true);
      }, delay);
    }
  }, [isRevealed, delay]);

  const tileClass = [
    'letter-tile',
    letter ? 'filled' : 'empty',
    shouldFlip && evaluation ? evaluation : '',
    shouldFlip ? 'flip' : '',
  ].filter(Boolean).join(' ');

  return (
    <div className={tileClass} role="tile">
      <div className="tile-front">{letter}</div>
      <div className="tile-back">{letter}</div>
    </div>
  );
}

export default LetterTile;